import { useContext } from 'react'
import { SearchParamContext } from './search-param-context'

export const useSearchParamContext = () => useContext(SearchParamContext)
